import {
    STAKEHOLDERS_PAGE_ITEM_REQUEST,
    STAKEHOLDERS_PAGE_ITEM_RESPONSE,
    STAKEHOLDERS_PAGE_LIST_REQUEST,
    STAKEHOLDERS_PAGE_LIST_RESPONSE,
    STAKEHOLDER_ADD_NEW,
    STAKEHOLDER_APPLY_FILTER_CRITERIA,
    STAKEHOLDER_APPLY_MODEL_UPDATE,
    STAKEHOLDER_CANCEL_MODEL_UPDATE,
    STAKEHOLDER_CLEAR_FILTER_CRITERIA,
    STAKEHOLDER_FINISH_SAVING,
    STAKEHOLDER_FINISH_SAVING_ERROR,
    STAKEHOLDER_ITEM_CACHED_RESPONSE,
    STAKEHOLDER_ITEM_ERROR_RESPONSE,
    STAKEHOLDER_ITEM_REQUEST,
    STAKEHOLDER_ITEM_RESPONSE,
    STAKEHOLDER_ITEM_SAVE_REQUEST,
    STAKEHOLDER_ITEM_SAVE_RESPONSE,
    STAKEHOLDER_LIST_CACHED_RESPONSE,
    STAKEHOLDER_LIST_ERROR_RESPONSE,
    STAKEHOLDER_LIST_REQUEST,
    STAKEHOLDER_LIST_RESPONSE,
    STAKEHOLDER_LIST_SEARCH_REQUEST,
    STAKEHOLDER_SET_EDIT_MODE,
    STAKEHOLDER_SET_FILTER,
    STAKEHOLDER_SHOW_INVALID_FIELDS,
    STAKEHOLDER_UPDATE_FILTER_CRITERIA,
    STAKEHOLDER_UPDATE_FILTER_TYPE,
    STAKEHOLDER_UPDATE_IMAGE,
    STAKEHOLDER_UPDATE_MODEL
} from "./action-types"
import {
    applyFilterCriteria,
    applyModelUpdate,
    cancelModelUpdate,
    clearFilterCriteria,
    defaultAction,
    itemRequest,
    listPageRequest,
    listSearchRequest,
    setEditMode,
    setFilter,
    updateFilterCriteria,
    updateImage,
    updateModel
} from "./default-actions/presentation-actions"
import {
    itemCachedResponse,
    itemErrorResponse,
    itemResponse,
    itemSaveRequest
} from "./default-actions/entity-actions"
import {
    listCachedResponse,
    listErrorResponse,
    listInvalidationRequest,
    listRequest,
    listResponse
} from "./default-actions/paging-actions"

// Actions specific to Stakeholders page
const stakeholdersPageListResponse = listResponse(
    STAKEHOLDERS_PAGE_LIST_RESPONSE
)
export const stakeholdersPageListRequest = listPageRequest(
    STAKEHOLDERS_PAGE_LIST_REQUEST,
    stakeholdersPageListResponse
)

const stakeholdersPageItemResponse = itemResponse(
    STAKEHOLDERS_PAGE_ITEM_RESPONSE
)
export const stakeholdersPageItemRequest = id => ({
    type: STAKEHOLDERS_PAGE_ITEM_REQUEST,
    id,
    callbackActionCreator: stakeholdersPageItemResponse
})

// Stakeholder Paging Actions
export const stakeholderListRequest = listRequest(STAKEHOLDER_LIST_REQUEST)
export const stakeholderListResponse = listResponse(STAKEHOLDER_LIST_RESPONSE)
export const stakeholderListCachedResponse = listCachedResponse(
    STAKEHOLDER_LIST_CACHED_RESPONSE
)
export const stakeholderListErrorResponse = listErrorResponse(
    STAKEHOLDER_LIST_ERROR_RESPONSE
)
export const stakeholderListInvalidationRequest = listInvalidationRequest(
    STAKEHOLDER_LIST_REQUEST
)
export const stakeholderListSearchRequest = listSearchRequest(
    STAKEHOLDER_LIST_SEARCH_REQUEST
)

// Entity Actions
export const stakeholderItemRequest = itemRequest(STAKEHOLDER_ITEM_REQUEST)
export const stakeholderItemResponse = itemResponse(STAKEHOLDER_ITEM_RESPONSE)
export const stakeholderItemCachedResponse = itemCachedResponse(
    STAKEHOLDER_ITEM_CACHED_RESPONSE
)
export const stakeholderItemErrorResponse = itemErrorResponse(
    STAKEHOLDER_ITEM_ERROR_RESPONSE
)
export const stakeholderItemSaveRequest = itemSaveRequest(
    STAKEHOLDER_ITEM_SAVE_REQUEST
)
export const stakeholderItemSaveResponse = itemResponse(
    STAKEHOLDER_ITEM_SAVE_RESPONSE
)

// Presentation Actions
export const stakeholderAddNew = defaultAction(STAKEHOLDER_ADD_NEW)
export const stakeholderSetFilter = setFilter(STAKEHOLDER_SET_FILTER)
export const stakeholderSetEditMode = setEditMode(STAKEHOLDER_SET_EDIT_MODE)
export const stakeholderUpdateModel = updateModel(STAKEHOLDER_UPDATE_MODEL)
export const stakeholderUpdateImage = updateImage(STAKEHOLDER_UPDATE_IMAGE)
export const stakeholderApplyModelUpdate = applyModelUpdate(
    STAKEHOLDER_APPLY_MODEL_UPDATE
)
export const stakeholderCancelModelUpdate = cancelModelUpdate(
    STAKEHOLDER_CANCEL_MODEL_UPDATE
)

// Filter actions
export const stakeholderApplyFilterCriteria = applyFilterCriteria(
    STAKEHOLDER_APPLY_FILTER_CRITERIA
)
export const stakeholderClearFilterCriteria = clearFilterCriteria(
    STAKEHOLDER_CLEAR_FILTER_CRITERIA
)
export const stakeholderUpdateFilterCriteria = updateFilterCriteria(
    STAKEHOLDER_UPDATE_FILTER_CRITERIA
)

export const stakeholderUpdateFilterType = activeFilterType => ({
    type: STAKEHOLDER_UPDATE_FILTER_TYPE,
    activeFilterType
})

export const stakeholderFinishSaving = defaultAction(STAKEHOLDER_FINISH_SAVING)
export const stakeholderFinishSavingError = defaultAction(
    STAKEHOLDER_FINISH_SAVING_ERROR
)

export const stakeholderShowInvalidFields = defaultAction(
    STAKEHOLDER_SHOW_INVALID_FIELDS
)
